import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { API_URL } from '../lib/api';

export default function useNotificationsWS(enabled = true) {
  const wsRef = useRef(null);
  const pingRef = useRef(null);
  const retryRef = useRef(0);

  useEffect(() => {
    if (!enabled) return;
    let mounted = true;

    const connect = () => {
      const token = localStorage.getItem('bp_access_token');
      if (!token || !API_URL) return;

      const wsBase = API_URL.replace(/^http/, 'ws');
      const url = `${wsBase}/api/ws/notifications?token=${encodeURIComponent(token)}`;
      const ws = new WebSocket(url);
      wsRef.current = ws;

      ws.onopen = () => {
        retryRef.current = 0;
        pingRef.current = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) ws.send('ping');
        }, 25000);
      };

      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.type === 'payment_received') {
            toast.success(data.title || 'Payment Received', {
              description: data.message,
              duration: 6000,
            });
            window.dispatchEvent(new CustomEvent('jjuma-pay:notification', { detail: data }));
          } else if (data.type === 'payment_failed') {
            toast.error(data.title || 'Payment Failed', { description: data.message });
            window.dispatchEvent(new CustomEvent('jjuma-pay:notification', { detail: data }));
          }
        } catch {}
      };

      ws.onclose = () => {
        if (pingRef.current) { clearInterval(pingRef.current); pingRef.current = null; }
        if (!mounted) return;
        retryRef.current += 1;
        const delay = Math.min(30000, 1000 * Math.pow(2, retryRef.current));
        setTimeout(() => { if (mounted) connect(); }, delay);
      };

      ws.onerror = () => { try { ws.close(); } catch {} };
    };

    connect();

    return () => {
      mounted = false;
      if (pingRef.current) clearInterval(pingRef.current);
      if (wsRef.current) {
        const ws = wsRef.current;
        try {
          if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CLOSING) {
            ws.close();
          } else if (ws.readyState === WebSocket.CONNECTING) {
            ws.onopen = () => { try { ws.close(); } catch {} };
          }
        } catch {}
      }
    };
  }, [enabled]);
}
